module.exports = __webpack_public_path__ + "img/kkiokio.def466c1.svg";